module.exports = __webpack_public_path__ + "static/redot2-4e8bc3b2586e7f554a2203b6632386c9.gif";